export const formatNumberToCurrency = (number) =>
  new Intl.NumberFormat('id', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  })
    .format(number)
    .replace(/\s+/g, ' ');
